import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaSkeleton } from "./VaSkeleton-60383291.mjs";
import { _ as _VaSkeletonGroup } from "./components/VaSkeletonGroup-6dbfa9ec.mjs";
const VaSkeleton = withConfigTransport(_VaSkeleton);
const VaSkeletonGroup = withConfigTransport(_VaSkeletonGroup);
export {
  VaSkeleton as V,
  VaSkeletonGroup as a
};
//# sourceMappingURL=index-4e0faf13.mjs.map
